import React from 'react';
import ReactDOM from 'react-dom';

import App from './App'; // Make sure the path is correct


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// Optional: You can remove this line if you're not using it
